import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo, useState } from 'react';
import { formErrorContext, formStateContext, formStateRefs } from '../context';

/**
 * Controls state of a single Field
 * @internal
 */
export var FormStateController = function FormStateController(_ref) {
  var children = _ref.children;
  var errorState = useState(undefined);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  var valuesUpdater = useCallback(function (key, value) {
    return setValues(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, _defineProperty({}, key, value));
    });
  }, []);
  var valuesContextValue = useMemo(function () {
    return [values, valuesUpdater];
  }, [values, valuesUpdater]);
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    refs = _useState4[0],
    setRefs = _useState4[1];
  var refsUpdater = useCallback(function (key, value) {
    return setRefs(function (oldState) {
      if (!value) {
        var removeThis = oldState[key],
          newState = _objectWithoutProperties(oldState, [key].map(_toPropertyKey));
        return newState;
      } else {
        return _objectSpread(_objectSpread({}, oldState), {}, _defineProperty({}, key, value));
      }
    });
  }, []);
  var refContextValue = useMemo(function () {
    return [refs, refsUpdater];
  }, [refs, refsUpdater]);
  return /*#__PURE__*/React.createElement(formErrorContext.Provider, {
    value: errorState
  }, /*#__PURE__*/React.createElement(formStateContext.Provider, {
    value: valuesContextValue
  }, /*#__PURE__*/React.createElement(formStateRefs.Provider, {
    value: refContextValue
  }, children)));
};